var map = {
	"./cha-bg.png": "G7iB",
	"./cha-lr-1.png": "yoOO",
	"./cha-lr-2.png": "h1ox",
	"./cha-lr-3.png": "3q13",
	"./cha-lr-4.png": "sX3y",
	"./cha-lr-5.png": "oLjS",
	"./cha-page-01.png": "SP6H",
	"./cha-page-02.png": "oBLc",
	"./cha-page-03.png": "53zK",
	"./cha-page-04.png": "1b0W",
	"./cha-page-05.png": "JCUh",
	"./cha-page-06.png": "rgvq",
	"./cha-page-07.png": "1YS9",
	"./cha-page-08.png": "sw13",
	"./cha1.png": "nGSZ",
	"./cha2.png": "vzTm",
	"./cha3.png": "8fOL",
	"./cha4.png": "MPzD",
	"./cha5.png": "HOpA",
	"./cha6.png": "/TF3",
	"./cha7.png": "UxZ/",
	"./cha8.png": "aaMp"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "EWkR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cha ^\.\/cha.*\.png$
// module id = EWkR
// module chunks = 1